import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { TabList } from '@/components/ui/navigation/TabList';
import { useEmployeeProfile } from '@/hooks/employee/useEmployeeProfile';
import { EmployeeProfilePersonalDataForm } from '@/components/features/employee/employeeProfilePersonalDataForm';
import { EmployeeProfileContactDataForm } from '@/components/features/employee/employeeProfileContactDataForm';
import { EmployeeProfileAddressDataForm } from '@/components/features/employee/employeeProfileAddressDataForm';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { toCapitalCase } from '@/utils';


export const EmployeeProfile: React.FC = () => {
  const {
    isLoading,
    error,
    profile,
    activeTab,
    setActiveTab,
    handleCancel,
    syncAssistance,
    genderOptions,
    maritalStatusOptions,
    employmentStatusOptions,
    regionOptions,
    communeOptions,
    workRegionOptions,
    workCommuneOptions,
    personalForm,
    contactForm,
    addressForm,
  } = useEmployeeProfile();

  if (error) {
    return (
      <PageLayout>
        <div className="flex flex-col gap-4 p-4" data-testid="employee-profile-error">
          <div className="text-red-600 text-sm">{error}</div>
          <div>
            <PrimaryButton variant="outline" onClick={handleCancel}>Volver al listado</PrimaryButton>
          </div>
        </div>
      </PageLayout>
    );
  }

  const tabs = [
    {
      id: 'personal',
      label: 'Datos personales',
      content: (
        <EmployeeProfilePersonalDataForm
          profile={profile}
          genderOptions={genderOptions}
          maritalStatusOptions={maritalStatusOptions}
          employmentStatusOptions={employmentStatusOptions}
          syncAssistance={syncAssistance}
          onCancel={handleCancel}
          personalForm={personalForm}
        />
      ),
    },
    {
      id: 'contact',
      label: 'Datos del contacto',
      content: (
        <EmployeeProfileContactDataForm
          profile={profile}
          onCancel={handleCancel}
          contactForm={contactForm}
        />
      ),
    },
    {
      id: 'address',
      label: 'Dirección',
      content: (
        <EmployeeProfileAddressDataForm
          profile={profile}
          regionOptions={regionOptions}
          communeOptions={communeOptions}
          workRegionOptions={workRegionOptions}
          workCommuneOptions={workCommuneOptions}
          onCancel={handleCancel}
          addressForm={addressForm}
        />
      ),
    },
  ];

  const dynamicTitle = toCapitalCase(profile?.firstNames + ' ' + profile?.lastName) || undefined;

  return (
    <PageLayout dynamicTitle={dynamicTitle} isLoading={isLoading}>
      <div data-testid="employee-profile-page">
        <TabList
          tabs={tabs}
          defaultActiveTab={activeTab}
          onTabChange={(id) => setActiveTab(id as any)}
        />
      </div>
    </PageLayout>
  );
};

export default EmployeeProfile;
